import { takeLatest, put, call } from 'redux-saga/effects';
import { getListCustoDespesaDireta } from '../service';
import { formatDateDDMMYYYY } from '@components/common/format';
import {
    CONFIG_SESSION,
    CUSTO_LIST_DESPESAS_DIRETAS,
    CUSTO_LIST_DESPESAS_DIRETAS_PENDING,
    CUSTO_LIST_DESPESAS_DIRETAS_SUCCESS,
    CUSTO_LIST_DESPESAS_DIRETAS_FAILURE,
} from '@handler';
import { storage } from '@commons/storage';

function* fetchListCustoDespesaDireta(action) {
  yield put({ type: CUSTO_LIST_DESPESAS_DIRETAS_PENDING });

  try {
    const session = JSON.parse(storage.get(CONFIG_SESSION));
    const idFazenda = session.fazendaSelecionada?.id ?? -1;
    const idSafra = session.safraAtiva?.id ?? -1;
    const dataInicial = formatDateDDMMYYYY(action.dataInicial);
    const dataFinal = formatDateDDMMYYYY(action.dataFinal);

    const dadosListCustosDespesasDireta = yield call(getListCustoDespesaDireta, idFazenda, idSafra, dataInicial, dataFinal);
    yield put({ type: CUSTO_LIST_DESPESAS_DIRETAS_SUCCESS, dadosListCustosDespesasDireta });
  } catch (err) {
    yield put({ type: CUSTO_LIST_DESPESAS_DIRETAS_FAILURE });
  }
}

export default function* watchListCustoDespesaDireta() {
  yield takeLatest(CUSTO_LIST_DESPESAS_DIRETAS, fetchListCustoDespesaDireta);
}
